/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown>, table: NonNullable<unknown> }} Rounds_Seating_SeatedInputs */



/**
* | output |
* | --- |
* | "Seated {name} at {table}" |
*
* @param {Rounds_Seating_SeatedInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const rounds_seating_seated = /** @type {((inputs: Rounds_Seating_SeatedInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rounds_Seating_SeatedInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`${i?.name} placé(e) à ${i?.table}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`${i?.name} sentado/a en ${i?.table}`)
	if (locale === "pt") return /** @type {LocalizedString} */ (`${i?.name} alocado/a em ${i?.table}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`${i?.name} seduto/a a ${i?.table}`)
	return /** @type {LocalizedString} */ (`Seated ${i?.name} at ${i?.table}`)
});